import React from 'react';
import Icon from '../common/Icon';
import { retryAllDamagePhotos, useDamagePhotoQueue } from '../../utils/damagePhotoQueue';
import './DamagePhotoCapture.css';

/** One line at the bottom while photos upload in the background, on any screen of the app. */
const UploadQueueIndicator = () => {
    const items = useDamagePhotoQueue();
    if (!items.length) return null;

    const failed = items.filter((item) => item.status === 'error');
    const active = items.length - failed.length;

    return (
        <div className={`upload-queue-indicator ${failed.length && !active ? 'has-error' : ''}`} role="status" aria-live="polite">
            <Icon name={active ? 'spinner' : 'warning'} spin={Boolean(active)} />
            <span>
                {active ? `Загрузка фото: осталось ${active}` : ''}
                {active && failed.length ? ' · ' : ''}
                {failed.length ? `не загружено ${failed.length}` : ''}
            </span>
            {failed.length > 0 && (
                <button type="button" onClick={retryAllDamagePhotos}>Повторить</button>
            )}
        </div>
    );
};

export default UploadQueueIndicator;
